























































































































































































































































































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Radios extends Vue {}
